import { Badge } from '@components';

export const getTrendIcon = (trend: 'up' | 'down'): string => {
  return trend === 'up' ? 'trending_up' : 'trending_down';
};

export const getTrendColor = (trend: 'up' | 'down'): string => {
  return trend === 'up' ? 'text-green-500' : 'text-red-500';
};

/**
 * Format trend value to 2 decimal places with % sign
 * @param trend - Trend value as string or number
 * @returns Formatted trend string (e.g., "-29.78%" or "+12.50%")
 */
export const formatTrend = (trend: string | number): string => {
  const trendValue = typeof trend === 'string' ? parseFloat(trend) : trend;
  if (isNaN(trendValue)) {
    return String(trend);
  }
  const sign = trendValue >= 0 ? '+' : '';
  return `${sign}${trendValue.toFixed(2)}%`;
};

export const getStatusBadge = (status: string, t: (key: string) => string) => {
  switch (status.toLowerCase()) {
    case 'online':
      return (
        <Badge variant="success" size="sm">
          {t('analytics.online')}
        </Badge>
      );
    case 'away':
      return (
        <Badge variant="warning" size="sm">
          {t('analytics.away')}
        </Badge>
      );
    case 'offline':
      return (
        <Badge variant="default" size="sm">
          {t('analytics.offline')}
        </Badge>
      );
    default:
      return (
        <Badge variant="default" size="sm">
          {status}
        </Badge>
      );
  }
};
